import pug from 'javascripts/confirmation_banner/templates/overlay_view.jst.pug';
window.JST = window.JST || {};
window.JST['confirmation_banner/templates/overlay_view'] = pug;
